import moment from 'moment'
import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './matches.jade'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import '@scoutgg/ftw/source/atoms/clipboard/clipboard'
import notify from '@scoutgg/ftw/source/services/notification'
import {Match, User} from '../../models'
import '../status'

@Component('sporty')
@Template(template)
@Attribute('weekly', Boolean)
@Attribute('before', moment)
@Attribute('after', moment)
@Attribute('user', String)
@Attribute('assigneduser', String)
@Attribute('sportfilter', String)
@Attribute('assignee', User)
@Attribute('delegate', User)
export default class Matches extends HTMLElement {
  created() {
    var stored = localStorage.getItem('season-filter')
    this.seasonFilter = stored ? JSON.parse(stored) : []
    this.tabs = ['closed', 'current', 'upcoming', 'urgent']
    this.tabCount = {}
    this.userOptions = [
      { value: 'all', label: '<any match>' },
      { value: 'claimed', label: '<claimed>' },
      { value: 'unclaimed', label: '<unclaimed>' }
    ]
  }


  attached() {
    this.dropdownShow = false
    this.weekly ?  this.tab = null : this.tab = 'current'
    this.shown = false
    this.showAssignButton = false
    this.reload()
  }

  beforeChange() {
    this.tab = null
    this.reload()
  }

  afterChange() {
    this.tab = null
    this.reload()
  }

  userChange() {
    this.reload()
  }

  assigneduserChange() {
    this.reload()
  }

  sportfilterChange() {
    this.reload()
  }
  reload() {
    var query = { $reload: true }
    if(this.sportfilter) {
      query.sport = this.sportfilter
    }
    if(this.before) {
      this.before = moment(this.before).endOf('day')
    }
    if(this.after) {
      this.after = moment(this.after).startOf('day')
    }
    if(this.assigneduser) {
      query.delegate = this.assigneduser
      if(this.before) {
        query.before = this.before
      }
      if(this.after) {
        query.after = this.after
      }
    } else {
      if(this.user && this.user !== 'any') query.user = this.user
      if(this.tab) {
        query.tab = this.tab
        if(this.before) {
          query.before = this.before
        }
        if(this.after) {
          query.after = this.after
        }
      } else if(!this.tab) {
        if(this.before) {
          query.before = this.before
        }
        if(this.after) {
          query.after = this.after
        }
      }
      if(this.seasonFilter.length) query.seasons = this.seasonFilter
    }
    const promise = Match.load(query)
    this.$promise = promise
    promise
      .then(({matches, seasons, seasonCount, tabCount, users}) => {
        if(promise !== this.$promise) return
        this.realMatches = matches
        this.seasons = seasons
        this.users = users
        const seasonIds = seasons.reduce((set, s) => set.add(s._id), new Set())
        this.seasonFilter = this.seasonFilter.filter(s => seasonIds.has(s))
        this.seasonCount = {}
        seasonCount.forEach(({_id, count}) => {
          this.seasonCount[_id] = count
        })
        this.tabCount = tabCount
        this.render()
      }).then((seasons) => {
        this.sortedSeasons = this.seasonSport.sort((a, b) => {
          return a.type.localeCompare(b.type)
        })
      })
  }

  sortedSportSeasons(sport) {
    return sport.sortedSeasons.sort((a, b) => a.name.localeCompare(b.name))
  }

  isClaimable(match) {
    return !match.user || match.user === User.current
  }

  tryClaiming(match, e, user, event) {
    if(match.user && match.user !== User.current) {
      location.href = '/matches/' + match._id
    } else {
      this.claim(match, e, user, event)
    }
  }

  claim(match, e, user, event) {
    e.stopPropagation()
    match = Match.instance(match)
    var prevUser = match.user
    var action
    if(user) {
      action = 'delegate'
      if(event === 'unassign') {
        match.delegate = null
        action = 'undelegate'
      } else {
        match.delegate = this.assignee
      }
    } else if(prevUser == User.current) {
      action = 'unclaim'
      match.user = null
    } else {
      action = 'claim'
      match.user = User.current
    }


    match.post(action, { user }).then(() => {
      if(action !== 'delegate' && action !== 'undelegate') {
        notify(`You've ${action}ed match ${match._id}`, {
          level: 'success',
          timeout: 5000,
        })
      } else {
        notify(`You've ${action}d match ${match._id}`, {
          level: 'success',
          timeout: 5000,
        })
      }
    }).catch(err => {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
      match.user = prevUser
      this.render()
    })
    this.render()
  }

  get seasonSport() {
    let seas = this.seasons
    var newArr = [],
        sports = {},
        cur
    for(const cur of this.seasons) {
      if (!(cur.sport in sports)) {
        sports[cur.sport] = {type: cur.sport, sortedSeasons: []}
        newArr.push(sports[cur.sport])
      }
      sports[cur.sport].sortedSeasons.push(cur)
    }
    return newArr
  }

  toggle(season) {
    var index = this.seasonFilter.indexOf(season)
    if(index < 0) {
      this.seasonFilter.push(season)
    } else {
      this.seasonFilter.splice(index, 1)
    }
    localStorage.setItem('season-filter', JSON.stringify(this.seasonFilter))
    this.reload()
  }

  setTab(tab) {
    this.tab = tab
    this.reload()
  }

  matchClass(match, weekly) {
    if(weekly) return this.matchClass(match) + ' ' + match.startTime.format('dddd')
    if(match.user && match.user === User.current) return 'owned'
    if(match.user) return 'claimed'
    var start = Date.parse(match.startTime)
    var isConfirmed = match.status === 'confirmed'
    if(!isConfirmed && !match.user && start < Date.now()) return 'urgent'
  }

  seasonClass(season) {
    if(this.seasonFilter.includes(season._id)) return 'selected'
  }
  deselect(){
    this.seasonFilter = []
    localStorage.removeItem('season-filter')
    this.render()
  }

  seasonsSelect() {
    this.shown = !this.shown
    this.render()
  }

  matchesConfirmation() {
    location.href = 'Sportsbook-confirmation'
  }

  showAssignTo() {
    this.showAssignButton = !this.showAssignButton
    this.render()
  }

  tabClass(tab) {
    if(tab === this.tab) return 'selected'
    if(tab === 'urgent' && this.tabCount.urgent) return 'urgent'
  }

  get score() {
    return (this.match && this.match.score) || [0, 0]
  }
  get subScore() {
    return (this.match && this.match.subScore) || [0, 0]
  }
  get phases() {
    return (this.match && this.match.phases) || [0, 0]
  }
  get phaseMax() {
    if(!this.match) return 0
    return this.match.periods || 0
  }
  get temporarAssetURL() {
    return 'https://statcenter.scoutgg.net/s3/uploads/assets/'
  }
}
